module.exports = __webpack_public_path__ + "img/RechargeHelp.e5e36547.png";